import { useCallback } from 'react'
import toast from 'react-hot-toast'
import { useTheme } from 'styled-components'

type ShowToastProps = {
  message: string
  duration?: number
}

const useToast = () => {
  const theme = useTheme()

  const showSuccessToast = useCallback(
    ({ message, duration = 4000 }: ShowToastProps) => {
      return toast.success(message, {
        position: 'bottom-center',
        style: {
          backgroundColor: theme.Components.Toaster.SuccessFill,
          color: theme.Components.Toaster.SuccessText,
        },
        duration,
      })
    },
    [theme],
  )

  const showErrorToast = useCallback(
    ({ message, duration = 4000 }: ShowToastProps) => {
      return toast.error(message, {
        position: 'bottom-center',
        style: {
          backgroundColor: theme.Components.Toaster.ErrorFill,
          color: theme.Components.Toaster.ErrorText,
        },
        duration,
      })
    },
    [theme],
  )

  return { showSuccessToast, showErrorToast }
}

export { useToast }
